import { VAlert } from 'vuetify/lib/components/VAlert';

var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.list && _vm.list.length)?_c('div',{staticClass:"alert-message"},_vm._l((_vm.list),function(message){return _c(VAlert,{key:message.id,attrs:{"type":message.style === 'none' ? 'info' : message.style,"color":message.style === 'none' ? 'primary' : '',"outlined":""}},[_c('span',{domProps:{"innerHTML":_vm._s(message.content)}})])}),1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }